module.exports = __webpack_public_path__ + "zvetseni-prsou_20_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_20_before.jpg
// module id = 1314
// module chunks = 0